export default [
    {
        title : 'Package Mapping',
        path: '/packageMapping',
        cName: 'sidebar-text'
    },
    {
        title : 'User Onboarding',
        path: '/userOnboarding',
        cName: 'sidebar-text'
    },
    {
        title : 'Master Control',
        path: '/masterControl',
        cName: 'sidebar-text'
    },
    {
        title : 'MIS Computation',
        path: '/MISComputation',
        cName: 'sidebar-text'
    },
    {
        title : 'Knowledge Base',
        path: '/knowledgeBase',
        cName: 'sidebar-text'
    }
]